(() => {
  const init = card => {
    if (card.dataset.cardReady) return;
    const dataNode = card.querySelector('[data-cft-card-variants]');
    const form = card.querySelector('[data-cft-card-form]');
    const native = card.querySelector('[data-cft-card-native]');
    if (!dataNode || !form || !native) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    if (!Array.isArray(data.variants) || !data.variants.length) return;
    const fields = [...form.querySelectorAll('[data-cft-card-option]')];
    const buy = card.querySelector('[data-cft-card-buy]');
    const price = card.querySelector('[data-cft-card-price]');
    const compare = card.querySelector('[data-cft-card-compare]');
    const image = card.querySelector('.cft-catalog-image');
    const options = form.querySelector('[data-cft-card-options]');
    const quantity = form.querySelector('[data-cft-card-quantity]');
    let busy = false;
    const abort = new AbortController();
    const listeners = { signal: abort.signal };
    const selectedVariant = () => {
      if (!fields.length) return data.variants.find(v => String(v.id) === native.value) || null;
      const values = fields.map(field => field.querySelector('input:checked')?.value);
      return data.variants.find(v => v.options.length === values.length &&
        values.every((value, index) => value !== undefined && value === v.options[index])) || null;
    };
    const syncOptions = variant => {
      if (!variant) return;
      fields.forEach((field, index) => {
        field.querySelectorAll('input').forEach(input => { input.checked = input.value === variant.options[index]; });
      });
    };
    const update = () => {
      const variant = selectedVariant();
      native.value = variant ? String(variant.id) : '';
      if (quantity) quantity.value = Number(variant?.quantityRule?.min) || 1;
      if (buy) {
        buy.disabled = busy || !variant?.available || data.requiresPlan;
        buy.textContent = busy ? 'Adding…' : !variant ? 'Unavailable' : !variant.available ? 'Sold out' : 'Add to bag';
      }
      price.textContent = variant?.price || '';
      compare.textContent = variant?.compare || '';
      compare.hidden = !variant?.compare;
      fields.forEach(field => {
        field.querySelector('[data-cft-card-selected]').textContent = field.querySelector('input:checked')?.value || '';
      });
      const destination = new URL(data.url, window.location.origin);
      if (variant) destination.searchParams.set('variant', variant.id);
      card.querySelectorAll('[data-cft-card-link]').forEach(link => {
        link.href = destination.pathname + destination.search;
      });
      if (image) {
        const src = variant?.image || data.image;
        if (src) {
          if (image.getAttribute('src') !== src) {
            image.src = src;
            image.removeAttribute('srcset');
          }
          image.hidden = false;
        } else image.hidden = true;
      }
    };
    native.addEventListener('change', () => {
      syncOptions(data.variants.find(v => String(v.id) === native.value));
      update();
    }, listeners);
    fields.forEach(field => field.addEventListener('change', update, listeners));
    form.addEventListener('submit', event => {
      const variant = selectedVariant();
      if (busy || !variant?.available || data.requiresPlan) { event.preventDefault(); return; }
      native.value = String(variant.id);
      busy = true;
      update();
    }, listeners);
    window.addEventListener('pageshow', () => { busy = false; update(); }, listeners);
    syncOptions(data.variants.find(v => String(v.id) === native.value));
    if (options) options.hidden = false;
    card.dataset.cardReady = 'true';
    card._cftCardDisconnect = () => { abort.abort(); delete card.dataset.cardReady; };
    update();
  };
  const scan = container => {
    if (container.matches?.('[data-cft-card]')) init(container);
    container.querySelectorAll('[data-cft-card]').forEach(init);
  };
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-cft-card]').forEach(card => card._cftCardDisconnect?.());
  });
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();
